import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select, { createFilter } from "react-select";
import { listPrograms } from "../../../store/actions/Member";
import {
  setInstituitionIDToRedux,
  setProgramDetails,
  setProgramFullDetails,
  setUserRole,
} from "../../../store/actions/MyProgram";
import { useCallback } from "react";
import { debounce } from "lodash";
import { setUMEHeader } from "../../../store/actions/Home";

const OwnDropDown = (props) => {
  const dispatch = useDispatch();
  const [programsList, setProgramsList] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState([]);
  const [searchTextGet, setSearchTextGet] = useState(null);
  const [prograrmID, setProgramID] = useState("");

  const [instituitionID, setInstituitionID] = useState("");
  const [openSelect, setOpenSelect] = useState(true);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenSelect(true);
      }
    };
    if (openSelect === false) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [openSelect]);
  const programList = useSelector(
    (state) =>
      state?.MemberReducer?.programList || state?.MyProgramReducer?.programList
  );
  const selectedProgramID = useSelector(
    (state) => state?.MyProgramReducer?.selectedProgram
  );
  const programFullList = useSelector(
    (state) => state?.MyProgramReducer?.programFullList
  );
  const userRole = useSelector((state) => state?.MyProgramReducer?.userRole);
  const { programDetailsUME } = useSelector((state) => state?.HomeReducer);

  const customOnClick = (data) => {
    setOpenSelect(openSelect ? false : true);
  };

  const customSelectItem = (data) => {
    const userRole = data.UserTypeID;
    setSelectedProgram(data?.label);
    setInstituitionID(data?.InstituitionID);
    setProgramID(data?.value);
    customOnClick();
    dispatch(setUserRole(userRole));
    dispatch(setUMEHeader(data));
  };

  const debouncedSave = useCallback(
    debounce((searchInput) => {
      let params = `?SearchTerm=${searchInput}`;
      dispatch(listPrograms(params));
    }, 900),
    []
  );

  const customOnchangeText = (event) => {
    debouncedSave(event.target.value);
    setSearchTextGet(event.target.value);
    const searchText = event.target.value;
    setSearch(searchText);
    localStorage.setItem("search", searchText);
  };

  useEffect(() => {
    if (!selectedProgramID || !programList?.data?.rows?.length) {
      dispatch(listPrograms(""));
    }
  }, [selectedProgramID, programList?.data?.rows?.length]);

  useEffect(() => {
    const updatedProgramsList = programList?.data?.rows?.map((item) => ({
      value: item.ID,
      label: item.Name,
      UserTypeID: item.UserTypeID,
      Type: item.Type,
      Instituition: item.Instituition,
      InstituitionID: item.InstituitionID,
    }));
    setProgramsList(updatedProgramsList);

    // Set the default value as the active program (restored from localStorage/redux) or fallback to first
    if (updatedProgramsList?.length > 0) {
      const activeProgramId = selectedProgramID || updatedProgramsList[0].value;
      const activeProgram = updatedProgramsList.find(
        (item) => String(item.value) === String(activeProgramId)
      ) || updatedProgramsList[0];

      setSelectedProgram(activeProgram.label);
      setProgramID(activeProgram.value);
      setInstituitionID(activeProgram.InstituitionID);
      dispatch(setUserRole(activeProgram.UserTypeID));
      dispatch(setUMEHeader(activeProgram));
    }
  }, [programList]);

  useEffect(() => {
    // Program id and fulldetails storing
    if (prograrmID && selectedProgram) {
      dispatch(setProgramDetails(prograrmID));

      dispatch(setInstituitionIDToRedux(instituitionID));
      dispatch(setProgramFullDetails(selectedProgram));
    }
  }, [prograrmID, selectedProgram, instituitionID]);

  useEffect(() => {
    const storedSearch = localStorage.getItem("search");
    if (storedSearch) {
      setSearch(storedSearch);
    }

    // Handle cleanup when the page is refreshed or closed
    const handleBeforeUnload = (event) => {
      localStorage.removeItem("search");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const triggerStyle = props.isModern
    ? {
        position: "relative",
        minHeight: "38px",
        height: "auto",
        width: "280px",
        background: "rgba(243, 243, 243, 0.6)",
        border: "1.5px solid #e5e7eb",
        borderRadius: "8px",
        cursor: "pointer",
        padding: "8px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: "14px",
        fontWeight: 600,
        color: "#1e1e2d",
        zIndex: 1,
        boxSizing: "border-box",
      }
    : {
        position: "relative",
        minHeight: "44px",
        height: "auto",
        width: "280px",
        border: "1px solid #3c3c3c",
        cursor: "pointer",
        padding: "8px 12px",
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxSizing: "border-box",
      };

  const listContainerStyle = props.isModern
    ? {
        position: "absolute",
        top: "100%",
        marginTop: "6px",
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.12)",
        padding: "8px",
        width: "280px",
        right: props?.hidingStyle ? 0 : 0,
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        boxSizing: "border-box",
      }
    : {
        position: "absolute",
        top: "100%",
        marginTop: "10px",
        background: "#fff",
        border: "1px solid #3c3c3c",
        padding: "10px 0",
        width: "280px",
        right: props?.hidingStyle ? "" : 0,
        zIndex: 2,
      };

  const inputStyle = props.isModern
    ? {
        width: "100%",
        height: "36px",
        border: "1.5px solid #e5e7eb",
        borderRadius: "8px",
        padding: "0 10px",
        fontSize: "14px",
        color: "#1e1e2d",
        outline: "none",
        boxSizing: "border-box",
        marginBottom: "4px",
      }
    : {
        width: "100%",
        height: "40px",
        fontSize: "16px",
        marginBottom: "5px",
      };

  const itemStyle = props.isModern
    ? {
        cursor: "pointer",
        padding: "8px",
        borderRadius: "8px",
        fontSize: "13.5px",
        fontWeight: 600,
        color: "#1e1e2d",
        textAlign: "left",
        listStyle: "none",
        transition: "background 0.2s ease",
      }
    : {
        cursor: "pointer",
        paddingBottom: "5px",
      };

  const wrapperStyle = props.isModern
    ? { position: "relative", display: "inline-block" }
    : { position: "relative" };

  const textStyle = props.isModern
    ? {
        flex: 1,
        textAlign: "left",
        marginRight: "8px",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
      }
    : {
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
      };

  return (
    <div style={wrapperStyle} ref={dropdownRef}>
      <div
        className={props.isModern ? "" : "selectWrapper"}
        style={triggerStyle}
        onClick={() => customOnClick()}
      >
        <span className="textOverflow" style={textStyle}>{selectedProgram}</span>
        {props.isModern && (
          <svg 
            style={{
              width: "14px",
              height: "14px",
              stroke: "#6b7280",
              transition: "transform 0.2s ease",
              transform: openSelect === false ? "rotate(180deg)" : "rotate(0deg)",
              flexShrink: 0,
            }}
            width="14" 
            height="14" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        )}
      </div>
      {openSelect === false ? (
        <div className="react-select-container" style={listContainerStyle}>
          <div style={props.isModern ? { width: "100%" } : { padding: "0 5px" }}>
            <input
              type="text"
              style={inputStyle}
              placeholder={props.isModern ? "Search Program Name..." : ""}
              onChange={customOnchangeText}
              value={search}
              onClick={(e) => props.isModern && e.stopPropagation()}
            ></input>
          </div>
          {programList?.data?.rows?.length > 0 ? (
            <ul
              className="react-select-ul"
              style={{
                margin: "0",
                listStyle: "none",
                padding: "0",
                minHeight: "auto",
                overflow: "auto",
              }}
            >
              {programsList?.map((data, index) => (
                <li
                  className={props.isModern ? "" : "customMenuItem"}
                  key={data.value}
                  style={props.isModern ? {
                    ...itemStyle,
                    backgroundColor: hoveredIndex === index ? "rgba(243, 243, 243, 0.8)" : "transparent",
                  } : itemStyle}
                  onMouseEnter={() => props.isModern && setHoveredIndex(index)}
                  onMouseLeave={() => props.isModern && setHoveredIndex(null)}
                  onClick={() => customSelectItem(data)}
                >
                  {data.label}
                </li>
              ))}
            </ul>
          ) : (
            <div
              style={{
                padding: "10px",
                display: "grid",
                placeContent: "center",
              }}
            >
              <span>No Data to Show</span>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default OwnDropDown;
